import { ListHttpResponse } from "../../_common/models/core.model";

export interface SalesStatementModel {    
    shopNumber: number,
    date: Date,
    printerNumber: number,
    documentNumber: number,
    fileId: number,
    receiptCount: number,
    netA: number,
    vatA: number,
    netB: number,
    vatB: number,
    netC: number,
    vatC: number,
    netD: number,
    vatD: number,
    netE: number,
    vatE: number,
    netF: number,
    vatF: number,
    netG: number,
    vatG: number,
    netH: number,
    vatH: number,
    gross: number
}

export function createEmptySalesStatementModel() : SalesStatementModel {
    return { shopNumber: null, date: null, printerNumber: null, documentNumber: null, fileId: null, receiptCount: null, netA: null, vatA: null, netB: null, vatB: null, netC: null, vatC: null, netD: null, vatD: null, netE: null, vatE: null, netF: null, vatF: null, netG: null, vatG: null, netH: null, vatH: null, gross: null }
}

export interface SalesStatementListResponse extends ListHttpResponse<SalesStatementModel> { }